import { IAnanlyticsCompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { IVehicle } from "interfaces/session/IVehicle";
import { getThumbnailSrcV2 } from "util/product/getThumbmailSrc";

export const pushEngageAddToCartEvent = (product: IAnanlyticsCompactProduct, selectedVehicle: IVehicle = {}) => {
  window.PushEngage = window.PushEngage || [];
  const time = new Date().getTime();
  const trigger = {
    campaign_name: "Cart Abandonment",
    event_name: "add-to-cart",
    // ref_id: `${product.sku}-${time}`,
    // optional, The user profile ID synchronized with PushEngage
    // profile_id: "<string>",
    data: {
      productname: product.longDescription,
      price: product.price / 100,
      notificationurl: `${process.env.NEXT_PUBLIC_ROOT_URL}/shopping-cart`,
      imageurl: getThumbnailSrcV2(product),
      ...selectedVehicle,
    //   bigimageurl: "<string>",
    },
  };

  PushEngage.push(() => {
    PushEngage.sendTriggerEvent(trigger)
      .then(() => {
      })
      .catch((error) => {
        console.log(error.message, error.details);
      });
  });
};

export const pushEngageCheckoutEvent = (totalAmount: number) => {
  const revenue = totalAmount / 100;
  window.PushEngage = window.PushEngage || [];
  const trigger = {
    campaign_name: "Cart Abandonment",
    event_name: "checkout",
    // optional, The user profile ID synchronized with PushEngage
    // profile_id: "<string>",
    data: {
      revenue,
    },
  };

  PushEngage.push(() => {
    PushEngage.sendTriggerEvent(trigger)
      .then(() => {
      })
      .catch((error) => {
        console.log(error.message, error.details);
      });
  });
};

let savedName = "";
export const pushEngageStartCheckoutEvent = (totalAmount: number, name?: string) => {
  if (savedName) {
    return;
  }
  if (name) {
    savedName = name;
  }
  pushEngageCheckoutEvent(totalAmount);

  window.PushEngage = window.PushEngage || [];
  const trigger = {
    campaign_name: "Checkout Abandonment",
    event_name: "checkout-start",
    // optional, The user profile ID synchronized with PushEngage
    // profile_id: "<string>",
    data: {
      price: totalAmount / 100,
      notificationurl: `${process.env.NEXT_PUBLIC_ROOT_URL}/shopping-cart`,
      imageurl: "https://assetscdn.pushengage.com/client_images/80417/1ihzlbhzcm1adsql7.png",
      name: name || "Hey",
    },
  };

  PushEngage.push(() => {
    PushEngage.sendTriggerEvent(trigger)
      .then((response) => {
      })
      .catch((error) => {
        console.log(error.message, error.details);
      });
  });
};

export const pushEngageCompleteCheckoutEvent = (totalAmount: number) => {
  window.PushEngage = window.PushEngage || [];
  const trigger = {
    campaign_name: "Checkout Abandonment",
    event_name: "checkout-complete",
    data: {
      revenue: totalAmount,
    },
  };

  PushEngage.push(() => {
    PushEngage.sendTriggerEvent(trigger)
      .then((response) => {
      })
      .catch((error) => {
        console.log(error.message, error.details);
      });
  });
};
